import { apiGet, apiDelete } from 'sow/utils/apiNew';
import { API_URL } from 'sow/constants/api';

export const loadAll = acaId => apiGet(`${API_URL}/v1/aca/${acaId}/certification_doc`);

export const deleteDoc = (acaId, docId) =>
  apiDelete(`${API_URL}/v1/aca/${acaId}/certification_doc/${docId}`);
